
import { createEntityAdapter, createSelector, Reducer, SliceCaseReducers } from "@reduxjs/toolkit";
import { FeedCurve } from "../..";
import { RootState } from "../../../../Store";
import { createAsyncEntitySlice } from "../../../../Store/Entities/createAsyncEntitySlice";
import { EnqueueFetcher } from "../../../../Store/Thunks/enqueueFetcher";
import { AsyncEntityState } from "../../../../Store/Thunks/asyncEntityStateUtil";
import { fetchFeedCurvesByIdsThunk } from "../../../../Store/Thunks/feedCurvesByIds";
import { entityByIdWithStatusHookFactory } from "../../../../Store/Entities/entityByIdWithStatusHookFactory";


export const feedCurveDataAdapter = createEntityAdapter({
  selectId: (feedCurve: FeedCurve) => feedCurve.feedCurveId
});


// Explicit typing is required
 const {reducer, actions, entityAdapter: feedCurveEntityAdapter}  = createAsyncEntitySlice<FeedCurve, number, SliceCaseReducers<AsyncEntityState<FeedCurve, number>>,FeedCurve>({
  name: "feedCurve",
  reducers: {
    addFeedCurve: feedCurveDataAdapter.addMany,
    updateFeedCurve: feedCurveDataAdapter.updateOne,
    updateManyFeedCurves: feedCurveDataAdapter.updateMany,
    upsertFeedCurves: feedCurveDataAdapter.upsertMany,
    clearFeedCurves: feedCurveDataAdapter.removeAll},
  fetchByIdsThunk: fetchFeedCurvesByIdsThunk,
  selectId:(feedCurve) => feedCurve.feedCurveId
})

export const feedCurveReducer = reducer as Reducer<AsyncEntityState<FeedCurve, number>>;

export const { addFeedCurve, updateFeedCurve, updateManyFeedCurves, clearFeedCurves, upsertFeedCurves,clearPendingIds, addPendingId, addLoadingIds } = actions;
export const {selectById: selectFeedCurveById, selectAll: SelectAllFeedCurves} = feedCurveEntityAdapter.getSelectors((state: RootState) => state.graphQlData.feedCurves);

const feedCurveFetcher = new EnqueueFetcher(fetchFeedCurvesByIdsThunk, (state) => state.graphQlData.feedCurves, clearPendingIds, addPendingId, addLoadingIds)

export const selectLoadingFeedCurvesIds = createSelector([(state: RootState) => state.graphQlData.feedCurves.loadingIds, (_, id: number) => id ],(loadingIds: number[], id: number) => loadingIds.includes(id))

export const useFeedCurveById = entityByIdWithStatusHookFactory(feedCurveFetcher.enqueueFetchById, selectFeedCurveById, selectLoadingFeedCurvesIds )